import { NavigateFunction } from 'react-router';

import { ICollectionFragment } from 'graphql/types';
import { getUrl } from 'route/utils/getUrl';

export function goToArticleDetailPage(navigate: NavigateFunction, id: string) {
    const url = getUrl('LIBRARY_ARTICLE', { id });
    navigate(url);
}

export function goToArticleContentEditPage(
    navigate: NavigateFunction,
    id: string
) {
    const url = getUrl('LIBRARY_ARTICLE_EDIT_CONTENT', { id });
    navigate(url);
}

export function goToRootCollectionDetailPage(navigate: NavigateFunction) {
    const url = getUrl('LIBRARY');

    navigate(url);
}

export function goToCollectionDetailPage(
    navigate: NavigateFunction,
    id: string | undefined // Used "| undefined" here to prevent issues with order of arguments
) {
    // LIBRARY_COLLECTION requires an id: getUrl throws without one. The root
    // collection has its own route.
    if (!id) {
        goToRootCollectionDetailPage(navigate);

        return;
    }

    const url = getUrl('LIBRARY_COLLECTION', { id });

    navigate(url);
}

export function goToParentCollection(
    navigate: NavigateFunction,
    parent: Pick<ICollectionFragment, 'id' | 'root'> | null | undefined
) {
    // The root collection lives at the library root, and so does anything
    // without a parent: only sub-collections carry an id in the url.
    if (!parent || parent.root) {
        goToRootCollectionDetailPage(navigate);

        return;
    }

    goToCollectionDetailPage(navigate, parent.id);
}
